import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import NoRecordFound from "../comman/NoRecordFound";
import Button from "@mui/material/Button";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Tooltip,
  Dialog,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import Sidebar from "../comman/Sidebar";
import Navbar from "../comman/Navbar";
import AttachmentRed from "../../images/attachment-red.svg";
import AttachmentGreen from "../../images/attachment-green.svg";
import Download from "../../images/Download.svg";
import RemoveIcon from "../../images/Remove-Icon.svg";
import Print from "../../images/Print.svg";
import {
  CONSOLIDATED_INVOICE_LIST,
  INVOICE_LIST,
} from "../../constants/RoutePath";
import { useLocation } from "react-router-dom";
import {
  UPSERT_INVOICE_STATEMENT_URL,
  GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
  GET_PROJECTS_ID,
  UPDATE_DAY_AND_MILEAGE_RATE_INVOICE_URL,
  GET_ALL_INVOICE_STATEMENT_BY_ID_URL,
} from "../../constants/ApiRoute";
import { authHeader, getLogUserId } from "../comman/MainFunction";
import {
  deCryptFun,
  enCryptFun,
  zipAndDownload,
} from "../comman/CustomFunction";
import RemoveConfirmation from "../model/RemoveConfirmation";
import API from "../comman/API";
import { useToast } from "../comman/CustomMessages";
const moment = require("moment");
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import NoBillingPeriodSelect from "../comman/NoBillingPeriodSelect";
import { useDispatch, useSelector } from "react-redux";
import * as types from "../../redux/action/ActionType";
import CustomLoader from "../comman/CustomLoader";
import CustomPageLoading from "../comman/CustomPageLoading";
import dayjs from "dayjs";

export default function ConsolidatedInvoice() {
  const showToast = useToast();
  const consolidateInvoiceListSelect = (state) =>
    state.ConsolidateInvoiceSelect;
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [matchedData, setMatchedData] = useState([]);
  console.log(matchedData, "matchedDatamatchedData");
  const [userList, setUserList] = useState([]);
  const [removeModel, setRemoveModel] = useState(false);
  const [removeBeokerName, setRemoveBrokerName] = useState("");
  const [doubleValidation, setDoubleValidation] = useState(false);
  const [removeItem, setRemoveItem] = useState("");
  const [removeBillingPeriodName, setRemoveBillingPeriodName] = useState("");
  const [loading, setLoading] = useState(false);
  const [removeItemBillingStartDate, setRemoveItemBillingStartDate] =
    useState("");
  const [removeItemBillingEndDate, setRemoveItemBillingEndDate] = useState("");
  const [removeBillingStatementItem, setRemoveBillingStatementItem] =
    useState("");
  const consoldiateCheckBoxFilter = useSelector(consolidateInvoiceListSelect);
  console.log(consoldiateCheckBoxFilter, "ncccccccccccccccc");
  let Invoiceobj = [
    { id: 1, value: "Statement Open" },
    { id: 2, value: "Statement Ready" },
    { id: 3, value: "Invoice Started" },
    { id: 4, value: "Invoice Closed" },
  ];

  // useEffect(() => {
  //   const { state } = location;
  //  console.log(state,'stataaaaaaaaaaa')
  //   if (!state) {
  //     navigate(INVOICE_LIST);
  //   } else if(state.matchedData && state.userList){
  //     setMatchedData(state.matchedData);
  //     setUserList(state.userList);
  //     // setMatchedData(matchedData);
  //     // setUserList(userList);
  //   }else{
  //     setMatchedData(consoldiateCheckBoxFilter?.matchedData);
  //     setUserList(consoldiateCheckBoxFilter?.userList);
  //   }
  // }, []);

  const generateClickDoubleValidation = () => {
    if (matchedData && matchedData.length == 1) {
      showToast(
        "To generate a consolidated invoice, please select at least two billing periods.",
        "error"
      );
    } else {
      setDoubleValidation(true);
    }
  };

  const handleClosingInvoiceYesClick = () => {
    generateInvoiceFunc();
    setDoubleValidation(false);
  };

  const handleClosingInvoiceNoClick = () => {
    setDoubleValidation(false);
  };

  const consolidateInvoiceFun = async () => {
    setLoading(true);
    console.log("Function called");
    console.log(consoldiateCheckBoxFilter?.periods, "periodsssssss");
    console.log(
      consoldiateCheckBoxFilter?.invoiceSingleCheckBox,
      "periodsssssss"
    );

    // Check if consoldiateCheckBoxFilter and periods are defined
    if (
      consoldiateCheckBoxFilter?.invoiceSingleCheckBox &&
      consoldiateCheckBoxFilter?.invoiceSingleCheckBox?.length > 0
    ) {
      let matchedData = consoldiateCheckBoxFilter?.periods?.filter(
        (item) =>
          consoldiateCheckBoxFilter.invoiceSingleCheckBox.includes(
            item.BillingStatemrntId
          ) && item?.statmentIds != ""
      );

      // Check if matchedData is found
      if (matchedData && matchedData.length > 0) {
        for (let data of matchedData) {
          try {
            const dataInvoiceStatement = await getInvoiceRowByID({
              projectId: data.ProjectID?.toString(),
              periodKey: data.PeriodKey,
            });

            // Ensure dataInvoiceStatement is an array before filtering
            const filtervalues = Array.isArray(dataInvoiceStatement)
              ? dataInvoiceStatement.filter((item) => item.StatusID === 2)
              : [];

            // Filter the available periods
            const avialablePeirds = filtervalues?.filter((item) =>
              consoldiateCheckBoxFilter?.billingPeriodsStatementIds.includes(
                item.BillingStatementID
              )
            );

            // Assign brokerDetail with available periods or an empty array if none
            data.brokerDetail = avialablePeirds?.length
              ? avialablePeirds
              : filtervalues;

            // Debugging logs
            console.log(filtervalues, "filtervalues");
            console.log(dataInvoiceStatement, "dataInvoiceStatement");
            console.log(avialablePeirds, "avialablePeirds");
          } catch (error) {
            console.error("Error processing data:", error);
          }
        }

        // Remove parent objects with empty brokerDetail arrays
        matchedData = matchedData.filter(
          (item) => item.brokerDetail?.length > 0
        );

        const getBillingStatemrntIds = (data) => {
          return data
            .flatMap((item) => item.BillingStatemrntId)
            .filter((id) => id !== ""); // Filter out any undefined values
        };

        // Example usage with matchedData
        const billingStatemrntIds = getBillingStatemrntIds(matchedData);
        const uniqueBillingStatemrntIds = [...new Set(billingStatemrntIds)];
        console.log(uniqueBillingStatemrntIds, "uniqueFilterStatementIds");
        console.log(
          uniqueBillingStatemrntIds,
          "filterStatementIdsfilterStatementIds"
        );

        // Check if matchedData is empty
        if (matchedData?.length === 0) {
          setMatchedData(consoldiateCheckBoxFilter?.matchedData);
          setUserList(consoldiateCheckBoxFilter?.userList);
        } else {
          setMatchedData(matchedData);
          setUserList(userList);
        }

        // Dispatch the action to Redux if needed
        // dispatch({
        //   type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
        //   payload: {
        //     ...consoldiateCheckBoxFilter,
        //     matchedData: matchedData,
        //     userList: userList,
        //     invoiceAllSelectCheckbox: consoldiateCheckBoxFilter?.invoiceSingleCheckBox?.length !== uniqueBillingStatemrntIds?.length ? "" : consoldiateCheckBoxFilter?.invoiceAllSelectCheckbox,
        //     invoiceSingleCheckBox: uniqueBillingStatemrntIds
        //   }
        // }),

        // Navigate to the consolidated invoice list
        // navigate(CONSOLIDATED_INVOICE_LIST, {
        //   state: { matchedData: matchedData, userList: userList },
        // });
        setLoading(false);
      }
    } else {
      console.error(
        "Check consoldiateCheckBoxFilter or periods, one of them is undefined or empty."
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    // You should not add matchedData or userList as dependencies because they are being set inside the function
    consolidateInvoiceFun();
  }, []); // Only run on component mount

  const getInvoiceRowByID = async (dataValue) => {
    // getAdminInvoiceStatementById(dataValue);
    const config = {
      method: "GET",
      url: GET_ALL_INVOICE_STATEMENT_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(dataValue)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse &&
        parsedResponse.billingStatementDetails &&
        parsedResponse.billingStatementDetails.length > 0
      ) {
        var billingStatementDetailArray =
          parsedResponse.billingStatementDetails;

        // for (let detail of billingStatementDetailArray) {
        //   var totalPerDiem = 0;
        //   var expenses = 0;
        //   var mileage = 0;
        //   var charges = 0;

        //   if (detail.PerDiem) {
        //     totalPerDiem = detail.PerDiem;
        //   }

        //   if (detail.Lodging || detail.Copies || detail.Misc) {
        //     if (detail.Lodging) {
        //       expenses = expenses + detail.Lodging;
        //     }
        //     if (detail.Copies) {
        //       expenses = expenses + detail.Copies;
        //     }
        //     if (detail.Misc) {
        //       expenses = expenses + detail.Misc;
        //     }
        //   }

        //   if (detail.Miles && detail.MileageRate) {
        //     mileage = detail.Miles * detail.MileageRate;
        //   }

        //   if (detail.Hours && detail.ProjectDayRate) {
        //     charges = (detail.Hours / 8) * detail.ProjectDayRate;
        //   }

        //   const totalValue =
        //     parseFloat(totalPerDiem) +
        //     parseFloat(expenses) +
        //     parseFloat(mileage) +
        //     parseFloat(charges);
        //   detail["Total"] = totalValue;
        // }

        return billingStatementDetailArray;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        // showToast(v.message, "error");
      }
      setLoading(false);
      return null; // Return null on error
    }
    setLoading(false);
  };

  console.log("userListuserListuserList", userList);

  console.log("matchedDataNewOne", matchedData);
  const generateInvoiceFunc = async () => {
    if (matchedData && matchedData.length >= 2) {
      var BrokerCount = 0;
      const sum = {
        Hours: 0,
        DayRate: 0,
        PerDiem: 0,
        Lodging: 0,
        Copies: 0,
        Misc: 0,
        Miles: 0,
        MileageRate: 0,
        Total: 0,
      };
      var headerIds = [];
      var projectIds = [];
      var userIds = [];
      var periodKeys = [];

      const matchedCustomerRow = consoldiateCheckBoxFilter?.userList.find(
        (item) => item.UserId === matchedData[0].CustomerID
      );

      const uniqueProjectIDs = Array.from(
        new Set(matchedData.map((item) => item.ProjectID))
      );
      BrokerCount = uniqueProjectIDs.reduce((sum, projectId) => {
        const filteredEntries = matchedData?.filter(
          (item) => item.ProjectID === projectId
        );
        const sumBrokerCount = filteredEntries.reduce(
          (acc, entry) => acc + entry.BrokerCount,
          0
        );
        return sum + sumBrokerCount;
      }, 0);

      var matchedProject = [];
      var matchedDataProjectIds = matchedData
        .filter((item) => item.StatusId.includes("2"))
        .map((item) => item.ProjectID)
        .join(",");
      const configProjectConfig = {
        method: "GET",
        headers: authHeader(),
        url: GET_PROJECTS_ID,
        params: {
          webString: enCryptFun(
            JSON.stringify({ projectIds: matchedDataProjectIds })
          ),
        },
      };
      try {
        const response = await API(configProjectConfig);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          matchedProject =
            parsedResponse && parsedResponse.ProjectDetails
              ? parsedResponse.ProjectDetails
              : [];
        }
      } catch (error) {}

      var headerArray = [];

      consoldiateCheckBoxFilter?.matchedData.forEach((item) => {
        projectIds.push(item.ProjectID);
        userIds.push(getLogUserId());
        periodKeys.push(item.PeriodKey);
        item.brokerDetail.forEach(async (detail) => {
          if (detail.StatusID && detail.StatusID == "2") {
            var billingDayRate = matchedProject.find(
              (project) => project.ProjectID === item.ProjectID
            );
            var billingMileageRate = billingDayRate
              ? billingDayRate.MileageRate
              : 0;

            // var totalPerDiem = 0;
            // var expenses = 0;
            // var mileage = 0;
            // var charges = 0;

            // if (detail.PerDiem) {
            //   totalPerDiem = detail.PerDiem;
            // }
            // if (detail.Lodging || detail.Copies || detail.Misc) {
            //   if (detail.Lodging) {
            //     expenses = expenses + detail.Lodging;
            //   }
            //   if (detail.Copies) {
            //     expenses = expenses + detail.Copies;
            //   }
            //   if (detail.Misc) {
            //     expenses = expenses + detail.Misc;
            //   }
            // }
            // if (detail.Miles && billingMileageRate) {
            //   mileage = detail.Miles * billingMileageRate;
            // }
            // if (detail.Hours && billingDayRate.BillingDayRate) {
            //   charges = (detail.Hours / 8) * billingDayRate.BillingDayRate;
            // }

            // const totalValue =
            //   parseFloat(totalPerDiem) +
            //   parseFloat(expenses) +
            //   parseFloat(mileage) +
            //   parseFloat(charges);

            sum.Hours += detail.Hours ? detail.Hours : 0;
            sum.DayRate += billingDayRate ? billingDayRate.BillingDayRate : 0;
            sum.PerDiem += detail.PerDiem ? detail.PerDiem : 0;
            sum.Lodging += detail.Lodging ? detail.Lodging : 0;
            sum.Copies += detail.Copies ? detail.Copies : 0;
            sum.Misc += detail.Misc ? detail.Misc : 0;
            sum.Miles += detail.Miles ? detail.Miles : 0;
            sum.MileageRate += billingMileageRate;
            sum.Total += detail.Total ? detail.Total : 0;

            var objheader = {
              ID: 0,
              projectId: detail.ProjID,
              periodKey: detail.PeriodKey,
              billingStart: detail.BillingStart,
              billingEnd: detail.BillingEnd,
              statusID: 3,
              brokerCount: detail.BrokerCount,
              brokerHours: detail.Hours,
              dayRate: billingDayRate ? billingDayRate.BillingDayRate : 0,
              selectedPrincipalRate:
                billingDayRate?.SelectedPrincipalRate ??
                billingDayRate?.selectedPrincipalRate ??
                billingDayRate?.PrincipalRate ??
                billingDayRate?.principalRate ??
                0,
              selectedProjectManagerRate:
                billingDayRate?.SelectedProjectManagerRate ??
                billingDayRate?.selectedProjectManagerRate ??
                billingDayRate?.ProjectManagerRate ??
                billingDayRate?.projectManagerRate ??
                0,
              selectedFieldAgentRate:
                billingDayRate?.SelectedFieldAgentRate ??
                billingDayRate?.selectedFieldAgentRate ??
                billingDayRate?.FieldAgentRate ??
                billingDayRate?.fieldAgentRate ??
                0,
              selectedDayRate: "Billable Rate",
              perDiem: detail.PerDiem,
              miles: detail.Miles,
              mileageRate: billingMileageRate,
              total: detail.Total,
              lodging: detail.Lodging,
              copies: detail.Copies,
              misc: detail.Misc,
            };
            headerArray.push(objheader);
            headerIds.push(detail.BillingStatementID);

            // console.log("objheader", objheader); // detail.MileageRate
            // console.log("objheader expenses", expenses);
            // console.log("objheader mileage", mileage);
            // console.log("objheader charges", charges);
            // console.log("objheader totalPerDiem", totalPerDiem);
          }
        });
      });

      let invoiceCreateObj = {
        invoiceId: 0,
        customerId: matchedData[0].CustomerID && matchedData[0].CustomerID,
        periodKey: periodKeys.join(","),
        projectId: projectIds.join(","),
        userId: userIds.join(","),
        statusId: 3,
        billingStart: null,
        billingEnd: null,
        invoiceDate: dayjs().utc().format(),
        createDate: dayjs().utc().format(),
        billToStreet1: matchedCustomerRow?.BAStreet1 ? matchedCustomerRow?.BAStreet1 : "",
        billToStreet2: matchedCustomerRow?.BAStreet2 ? matchedCustomerRow?.BAStreet2 : "",
        billToCity: matchedCustomerRow?.BACity ? matchedCustomerRow?.BACity : "",
        billToState: matchedCustomerRow?.BAState ? matchedCustomerRow?.BAState : "",
        billToZip: matchedCustomerRow?.BAZip,
        brokerCount: BrokerCount,
        brokerHours: sum.Hours,
        dayRate: sum.DayRate,
        perDiem: sum.PerDiem,
        lodging: sum.Lodging,
        miles: sum.Miles,
        misc: sum.Misc,
        copies: sum.Copies,
        mileageRate: sum.MileageRate,
        invoiceTotal: sum.Total,
        headerIds: headerIds.join(","),
        isConsolidated: true,
      };

      const config = {
        method: "POST",
        url: UPSERT_INVOICE_STATEMENT_URL,
        headers: authHeader(),
        data: { webString: enCryptFun(JSON.stringify(invoiceCreateObj)) },
      };

      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.billingStatementId) {
          console.log("parsedResponse", parsedResponse);
          showToast("Invoice Statement Created Successfully", "success");
          if (parsedResponse.billingStatementId) {
            headerArray.forEach((item) => {
              item.invoiceId = parsedResponse.billingStatementId;
            });
            updateDayAndMileageRate(
              headerArray,
              parsedResponse.billingStatementId
            );
            dispatch({
              type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
              payload: {
                matchedData: [],
                userList: [],
                invoiceAllSelectCheckbox: "",
                invoiceSingleCheckBox: "",
              },
            });
          }
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          if (v.message == "This invoice is closed and cannot be edited.") {
            showToast(v.message, "error");
          } else {
            showToast(v.message, "error");
            consolidateInvoiceFun();
          }
        }
      }
    }
  };

  const updateDayAndMileageRate = async (headerArray, invoiceId) => {
    const data = {
      consolidatedProjects: JSON.stringify(headerArray),
    };
    const config = {
      method: "POST",
      headers: authHeader(),
      url: UPDATE_DAY_AND_MILEAGE_RATE_INVOICE_URL,
      data: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        navigate(`/consolidated-invoice-form/${invoiceId}`);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*

var totalPerDiem = 0;
var expenses = 0;
var mileage = 0;
var charges = 0;

if(sum.PerDiem){
totalPerDiem = sum.PerDiem
}
if(sum.Lodging || sum.Copies || sum.Misc){
if(sum.Lodging){
expenses = expenses + sum.Lodging
}
if(sum.Copies){
expenses = expenses + sum.Copies
}
if(sum.Misc){
expenses = expenses + sum.Misc
}
}
if(sum.Miles && sum.MileageRate){
mileage = sum.Miles * sum.MileageRate
}
if(sum.Hours && sum.DayRate){
charges = (sum.Hours / 8) * sum.DayRate
}
const totalValue = parseFloat(totalPerDiem) + parseFloat(expenses) + parseFloat(mileage) + parseFloat(charges);




  const generateInvoiceFuncOLD = async () => {
    if (matchedData && matchedData.length > 0) {
      var invoiceId = "";

      for (let selectedInvoicePeriod of matchedData) {
        const matchedCustomerRow = userList.find(
          (item) => item.UserId === selectedInvoicePeriod.CustomerID
        );

        for (let data of selectedInvoicePeriod.brokerDetail) {
          let invoiceCreateObj = {
            invoiceId: 0,
            customerId:
              selectedInvoicePeriod.CustomerID &&
              selectedInvoicePeriod.CustomerID,
            periodKey: data.PeriodKey,
            projectId: data.ProjID,
            statusId: 3,
            billingStart: data.BillingStart,
            billingEnd: data.BillingStart,
            invoiceDate: new Date().toISOString(),
            createDate: new Date().toISOString(),
            billToStreet1: matchedCustomerRow.BAStreet1,
            billToStreet2: matchedCustomerRow.BAStreet2,
            billToCity: matchedCustomerRow.BACity,
            billToState: matchedCustomerRow.BAState,
            billToZip: matchedCustomerRow.BAZip,
            brokerCount: selectedInvoicePeriod.BrokerCount,
            brokerHours: data.Hours,
            dayRate: data.DayRate,
            perDiem: data.PerDiem,
            lodging: data.Lodging,
            miles: data.Miles,
            misc: data.Misc,
            copies: data.Copies,
            mileageRate: data.MileageRate,
            invoiceTotal: data.Total,
            headerIds: data.BillingStatementID.toString(),
          };

          const config = {
            method: "POST",
            url: UPSERT_INVOICE_STATEMENT_URL,
            headers: authHeader(),
            data: { webString: enCryptFun(JSON.stringify(invoiceCreateObj)) },
          };

          try {
            const response = await API(config);
            let decryptedResponse = deCryptFun(response.data);
            const parsedResponse = JSON.parse(decryptedResponse);
            if (parsedResponse.billingStatementId) {
              console.log("parsedResponse", parsedResponse)
              showToast("Invoice Statement Created Successfully", "success");
              if (parsedResponse.billingStatementId) {
                navigate(`/consolidated-invoice-form/${parsedResponse.billingStatementId}`);
              }
            }
          } catch (error) {}
        }
      }

      showToast("Invoice Statement Created Successfully", "success");

      if (invoiceId) {
        navigate(`/consolidated-invoice-form/${invoiceId}`);
      }
    }
  };
  */

  const removeItemFunc = (value, name, startDate, endDate) => {
    setRemoveItem(value);
    setRemoveBillingPeriodName(name);
    setRemoveItemBillingStartDate(startDate);
    setRemoveItemBillingEndDate(endDate);
    setRemoveBillingStatementItem("");
    setRemoveModel(true);
  };

  const removeBillingStatementRow = (rowId, brokerName, removeId) => {
    console.log(rowId, "removeBillingStatementRow", brokerName, removeId);
    setRemoveItem(rowId);
    setRemoveBillingStatementItem(removeId);
    setRemoveModel(true);
    setRemoveBrokerName(brokerName);
  };

  const removeItemFuncConfirm = (value, type) => {
    const { removeItem } = value;

    console.log(value, "valueeeeeeeeeeeee", type);

    if (value && type == "statementRow") {
      setMatchedData((prevData) =>
        prevData.filter(
          (item) => item.BillingStatemrntId !== removeItem?.BillingStatemrntId
        )
      );
      showToast(
        `Billing for Project: ${removeItem?.ProjectName}, Billing Period: ${removeItem?.BillingDate} was successfully removed.`,
        "success"
      );
    } else if (value && type === "statementId") {
      console.log("statementId", value, matchedData);

      // Show a success toast message
      showToast(
        `Billing for ${removeItem.brokerDetail[0].BrokerName} (Project: ${removeItem?.ProjectName}, Statement ID: ${value?.removeBillingStatementItem}) was successfully removed.`,
        "success"
      );

      setMatchedData((prevData) =>
        prevData.map((statement) => {
          // Filter out brokers with the matching BillingStatementID and StatusID
          const filteredBrokerDetail = statement.brokerDetail.filter(
            (broker) =>
              broker.BillingStatementID !== value.removeBillingStatementItem ||
              broker.StatusID !== 2
          );

          console.log("Filtered BrokerDetail:", filteredBrokerDetail);

          const filterStatusID = filteredBrokerDetail?.filter(
            (broker) => broker.StatusID === 2
          );

          console.log("Filtered BrokerDetailfilterStatusID:", filterStatusID);

          // Return the statement with the updated brokerDetail
          return {
            ...statement,
            brokerDetail: filterStatusID,
          };
        })
      );

      // Update the matchedData state with filtered data
      // setMatchedData((prevData) =>
      //   prevData
      //     .filter((statement) => {
      //       // Filter out brokers where the StatusID is 2 and BillingStatementID matches
      //       const filteredBrokerDetail = statement.brokerDetail.filter(
      //         (broker) => broker.StatusID === 2 && broker.BillingStatementID === value?.removeBillingStatementItem
      //       );

      //       console.log(filteredBrokerDetail, 'filteredBrokerDetail[0].BillingStatementID', value.removeBillingStatementItem);
      //       console.log(statement, 'statement.BillingStatemrntId', value.removeBillingStatementItem);

      //       // If the filtered brokers array is empty or has only one match, and the statement ID matches, remove the statement
      //       if (
      //         (filteredBrokerDetail.length === 0 || filteredBrokerDetail.length === 1) &&
      //         filteredBrokerDetail[0]?.BillingStatementID === value.removeBillingStatementItem
      //       ) {
      //         return false; // Exclude this statement
      //       }

      //       return true; // Keep this statement
      //     })
      //     .map((statement) => {
      //       // Filter broker details to exclude brokers matching removeBillingStatementItem and StatusID of 2
      //       const updatedBrokerDetail = statement.brokerDetail.filter(
      //         (broker) => broker.BillingStatementID !== value.removeBillingStatementItem && broker.StatusID === 2
      //       );

      //       console.log(
      //         statement.BillingStatemrntId === removeItem.BillingStatemrntId,
      //         'filteredBrokerDetail[0]?.BillingStatementID === value.removeBillingStatementItem',
      //         updatedBrokerDetail,
      //         value.removeBillingStatementItem
      //       );

      //       console.log(
      //         statement.brokerDetail.filter(
      //           (broker) => broker.BillingStatementID !== value.removeBillingStatementItem
      //         ),
      //         'statement.brokerDetail.filter((broker)',
      //         statement
      //       );

      //       // Modify the statement if it matches the removed BillingStatemrntId
      //       if (statement.BillingStatemrntId === removeItem.BillingStatemrntId) {
      //         console.log(
      //           statement.brokerDetail.filter(
      //             (broker) => broker.BillingStatementID !== value.removeBillingStatementItem
      //           ),
      //           'Filtered broker details for statement modification',
      //           statement
      //         );
      //         // Update the brokerDetail array by excluding brokers with the removed BillingStatementID
      //         return {
      //           ...statement,
      //           brokerDetail: updatedBrokerDetail
      //         };
      //       }

      //       // Return the statement as is if no modification is needed
      //       return statement;
      //     })
      // );
    }
    // Reset states after removal
    setRemoveItem("");
    setRemoveBillingStatementItem("");
    setRemoveModel(false);
  };

  useEffect(() => {
    if (matchedData?.length >= 0) {
      const nobillingperiodAvilable = matchedData.filter(
        (item) => item.brokerDetail?.length > 0
      );
      const getBillingStatemrntIds = (data) => {
        return data
          .flatMap((item) => item.BillingStatemrntId)
          .filter((id) => id !== ""); // Filter out any undefined values
      };

      const getBillingPeriodsStatemrntIds = (data) => {
        return data.flatMap(
          (item) =>
            Array.isArray(item.brokerDetail) // Check if brokerDetail is an array
              ? item.brokerDetail
                  .map((broker) => broker.BillingStatementID) // Extract BillingStatementID
                  .filter((id) => id !== null && id !== "") // Filter out invalid IDs
              : [] // If brokerDetail is not an array, return an empty array
        );
      };

      console.log(
        nobillingperiodAvilable,
        "nobillingperiodAvilablenobillingperiodAvilable"
      );

      const billingStatemrntIds = getBillingStatemrntIds(
        nobillingperiodAvilable
      );
      const billingPeriodStatemrntIds = getBillingPeriodsStatemrntIds(
        nobillingperiodAvilable
      );
      const uniqueBillingStatemrntIds = [...new Set(billingStatemrntIds)];
      const uniqueBillingPeriodStatemrntIds = [
        ...new Set(billingPeriodStatemrntIds),
      ];
      console.log(
        uniqueBillingPeriodStatemrntIds,
        "uniqueBillingPeriodStatemrntIdsuniqueBillingPeriodStatemrntIds"
      );
      dispatch({
        type: types?.CONSOLIDATE_INVOICE_LIST_SELECT,
        payload: {
          ...consoldiateCheckBoxFilter,
          matchedData: nobillingperiodAvilable,
          invoiceAllSelectCheckbox: "",
          invoiceSingleCheckBox: uniqueBillingStatemrntIds,
          billingPeriodsStatementIds: uniqueBillingPeriodStatemrntIds,
        },
      });
    }
  }, [matchedData]);

  const attachmentDownloadFunction = async (selectedInvoicePeriod) => {
    console.log(selectedInvoicePeriod, "selectedhhhhhhhhhhh");
    let data = {
      // projectId: selectedInvoicePeriod.ProjectID,
      billingStatementId: selectedInvoicePeriod.BillingStatemrntId,
      userId: selectedInvoicePeriod.brokerDetail[0].UserID,
      type: 1,
      parentTypeId : 1
    };

    const config = {
      method: "GET",
      url: GET_ATTACHMENT_BY_BILLING_PROJECT_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse &&
        parsedResponse.data &&
        parsedResponse.data.length > 0
      ) {
        handleDownload(parsedResponse.data, selectedInvoicePeriod);
        // handleDownload(parsedResponse.data);
        // zipAndDownload(parsedResponse.data);
      }

      console.log("parsedResponse", parsedResponse);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
      return null; // Return null on error
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert ISO string to Date object
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month (0-based index)
    const day = date.getDate().toString().padStart(2, "0"); // Day
    const year = date.getFullYear(); // Year
    return `${month}${day}${year}`; // Concatenate as MMDDYYYY
  };

  const handleDownload = async (
    attachmentFileObject,
    selectedInvoicePeriod
  ) => {
    console.log(
      attachmentFileObject,
      "gggggggggggggggg",
      selectedInvoicePeriod
    );
    const expectedFormat =
      formatDate(selectedInvoicePeriod.BillingStart) +
      formatDate(selectedInvoicePeriod.BillingEnd);

    console.log(expectedFormat, "expectedFormatexpectedFormat");
    // setDownloadLoading(true);
    const zip = new JSZip();
    const folder = zip.folder();
    try {
      // Fetch images and add them to the zip
      const fetchPromises = attachmentFileObject.map(async (photo, index) => {
        // setDownloadLoading(true);
        try {
          const response = await fetch(photo.Path);
          if (!response.ok) {
            throw new Error(
              `Failed to fetch ${photo.Path}. Status: ${response.status}, Status Text: ${response.statusText}`
            );
          }

          const blob = await response.blob();
          let fileName = photo.FileName;

          // Check for duplicate filenames
          let duplicateCount = 0;
          const originalFileName = fileName;

          // Ensure uniqueness by appending an index if a duplicate exists
          while (folder.files[`${fileName}`]) {
            duplicateCount += 1;
            const lastDotIndex = originalFileName.lastIndexOf(".");
            const nameWithoutExt = originalFileName.substring(0, lastDotIndex);
            const ext = originalFileName.substring(lastDotIndex); // Includes the dot
            fileName = `${nameWithoutExt} (${duplicateCount})${ext}`;
          }

          // Add file to the zip with the unique file name
          folder.file(fileName, blob);
        } catch (error) {
          console.error(`Error fetching ${photo.Path}:`, error);
        }
      });

      // Wait for all fetch promises to resolve
      await Promise.all(fetchPromises);

      // Generate the zip file and save it
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(
        zipBlob,
        `${attachmentFileObject[0]?.UserName}_${selectedInvoicePeriod.ProjectName}_${expectedFormat}.zip`
      );
    } catch (error) {
      console.error("Error generating or saving zip file:", error);
    } finally {
      // setDownloadLoading(false);
    }
  };

  return (
    <div>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"5"} />

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar
            title="Consolidated Invoice"
            backFlag={true}
            backRoute={INVOICE_LIST}
          />

          <Box sx={{ mt: "20px", pt: "12px", pb: "0px" }} className="bg-box">
            <div>
              <AccordionSummary
                sx={{ alignItems: "center", p: "0px 10px" }}
                className="statement-period-title"
                expandIcon={
                  consoldiateCheckBoxFilter?.matchedData &&
                  consoldiateCheckBoxFilter?.matchedData.length > 0 ? (
                    <Button
                      sx={{ ml: "74px" }}
                      className="primary-btn"
                      onClick={generateClickDoubleValidation}
                      disabled={
                        consoldiateCheckBoxFilter?.matchedData &&
                        consoldiateCheckBoxFilter?.matchedData.length > 0
                          ? false
                          : true
                      }
                    >
                      Generate Invoice
                    </Button>
                  ) : (
                    ""
                  )
                }
                aria-controls="panel1-content"
                id="panel1-header"
                style={{ marginBottom: "0px" }}
              >
                Billing Statement in Selected Period
              </AccordionSummary>
              {loading && (
                <Grid item xs={12} align="center">
                  <CustomPageLoading disableShrink />
                </Grid>
              )}
              {!loading &&
                matchedData &&
                matchedData
                  ?.sort((a, b) => {
                    // First, compare based on ProjID or InvProjectID
                    const projA = a?.ProjectID;
                    const projB = b?.ProjectID;

                    if (projA !== projB) {
                      // If ProjID (or InvProjectID) is different, sort by ProjID
                      return projA - projB;
                    } else {
                      // If ProjID (or InvProjectID) is the same, sort by startDate, then endDate
                      const dateAStart = new Date(a.BillingStart);
                      const dateBStart = new Date(b.BillingStart);

                      const dateAEnd = new Date(a.BillingEnd);
                      const dateBEnd = new Date(b.BillingEnd);

                      // Sort by startDate first
                      if (dateAStart.getTime() !== dateBStart.getTime()) {
                        return dateAStart - dateBStart;
                      }

                      // If startDate is the same, sort by endDate
                      return dateAEnd - dateBEnd;
                    }
                  })
                  ?.map(
                    (row, index) =>
                      row?.brokerDetail?.length > 0 && (
                        <AccordionDetails
                          sx={{ padding: "8px 10px 16px" }}
                          key={index}
                        >
                          <Box className="datebox-title">
                            {/* <Grid container>
                  <Grid xs={10} md={10}> */}

                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              spacing={2}
                            >
                              <Grid xs={10} md={10}>
                                <Typography>
                                  {row.ProjectName} -{" "}
                                  {moment(row.BillingStart).format(
                                    "MM/DD/YYYY"
                                  )}{" "}
                                  -{" "}
                                  {moment(row.BillingEnd).format("MM/DD/YYYY")}
                                </Typography>
                              </Grid>

                              <Grid xs={2} md={2}>
                                <Typography
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    removeItemFunc(
                                      row,
                                      row.ProjectName,
                                      row.BillingStart,
                                      row.BillingEnd
                                    )
                                  }
                                >
                                  Remove{" "}
                                </Typography>
                              </Grid>
                            </Stack>
                          </Box>
                          <TableContainer
                            className="statement-date-table"
                            sx={{ mt: "10px", pl: "5px" }}
                          >
                            <Table
                              sx={{ minWidth: 650 }}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell sx={{ minWidth: "103px" }}>
                                    Statement ID
                                  </TableCell>
                                  <TableCell>Broker Name</TableCell>
                                  <TableCell sx={{ minWidth: "120px" }}>
                                    Invoice Number
                                  </TableCell>
                                  <TableCell sx={{ minWidth: "65px" }}>
                                    Hours
                                  </TableCell>
                                  <TableCell sx={{ minWidth: "106px" }}>
                                    Last Modified
                                  </TableCell>
                                  <TableCell>Status</TableCell>
                                  <TableCell sx={{ minWidth: "65px" }}>
                                    Total
                                  </TableCell>
                                  <TableCell>Action</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {row.brokerDetail &&
                                  row.brokerDetail.length > 0 &&
                                  row.brokerDetail.map((b_row, b_index) => {
                                    if (
                                      b_row.StatusID &&
                                      b_row.StatusID == "2"
                                    ) {
                                      return (
                                        <TableRow key={b_index}>
                                          <TableCell>
                                            {b_row.BillingStatementID}
                                          </TableCell>
                                          <TableCell
                                            sx={{
                                              wordBreak: "break-all",
                                              minWidth: "222px",
                                              maxWidth: "222px",
                                            }}
                                          >
                                            {b_row.BrokerName}
                                          </TableCell>
                                          <TableCell>
                                            {b_row.BillingStatementID &&
                                            b_row.InvoiceID ? (
                                              <Tooltip
                                                title="Click here to view the invoice details"
                                                arrow
                                              >
                                                <a
                                                  href={
                                                    b_row.IsConsolidated
                                                      ? `/consolidated-invoice-form/${b_row.InvoiceID}`
                                                      : `/invoice-form/${b_row.InvoiceID}`
                                                  }
                                                  // target="_blank"
                                                >
                                                  <span
                                                    style={{
                                                      color: "#007fff",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    #{b_row.InvoiceID}
                                                  </span>
                                                </a>
                                              </Tooltip>
                                            ) : (
                                              "--"
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {b_row.Hours
                                              ? `${b_row.Hours.toFixed(2)}`
                                              : "0.00"}
                                          </TableCell>
                                          <TableCell>
                                            {moment(b_row.LastModified).format(
                                              "MM/DD/YYYY"
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {Invoiceobj.find(
                                              (item) =>
                                                Number(item.id) ===
                                                Number(b_row.StatusID)
                                            )?.value || "--"}
                                          </TableCell>
                                          <TableCell>
                                            $
                                            {b_row.Total
                                              ? `${b_row.Total?.toFixed(2)}`
                                              : "0.00"}
                                          </TableCell>
                                          <TableCell>
                                            <Stack
                                              className="action-icons"
                                              direction="row"
                                              spacing={1}
                                            >
                                              <Tooltip
                                                arrow
                                                className="project-tooltip"
                                                title="Click here to get all attachments for this statement."
                                                placement="top"
                                              >
                                                <img
                                                  src={Download}
                                                  onClick={() =>
                                                    attachmentDownloadFunction(
                                                      row
                                                    )
                                                  }
                                                  alt="Download"
                                                />
                                              </Tooltip>
                                              <Tooltip
                                                arrow
                                                className="project-tooltip"
                                                title="Click here to print this statement."
                                                placement="top"
                                              >
                                                <img
                                                  src={Print}
                                                  onClick={() =>
                                                    window.open(
                                                      `/print-billing-statement/${b_row.BillingStatementID}`,
                                                      "_blank"
                                                    )
                                                  }
                                                />
                                              </Tooltip>
                                              <Tooltip
                                                arrow
                                                className="project-tooltip"
                                                title="Click here to remove this statement."
                                                placement="top"
                                              >
                                                <img
                                                  src={RemoveIcon}
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() =>
                                                    removeBillingStatementRow(
                                                      row,
                                                      b_row.BrokerName,
                                                      b_row.BillingStatementID
                                                    )
                                                  }
                                                  alt="Remove"
                                                />
                                              </Tooltip>
                                            </Stack>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      )
                  )}

              {!loading &&
              (!consoldiateCheckBoxFilter?.matchedData ||
                consoldiateCheckBoxFilter?.matchedData.length == 0) ? (
                <AccordionDetails sx={{ padding: "8px 10px 16px" }} key={1}>
                  <Box>
                    {/* <Grid container>
              <Grid xs={10} md={10}> */}

                    <NoBillingPeriodSelect />
                  </Box>
                </AccordionDetails>
              ) : (
                ""
              )}
            </div>
          </Box>
        </Box>
      </Box>

      {removeModel && (
        <RemoveConfirmation
          open={removeModel}
          removeItem={removeItem}
          removeBillingStatementItem={removeBillingStatementItem}
          removeItemFuncConfirm={removeItemFuncConfirm}
          removeBillingPeriodName={removeBillingPeriodName}
          removeItemBillingStartDate={removeItemBillingStartDate}
          removeItemBillingEndDate={removeItemBillingEndDate}
          removeBrokerName={removeBeokerName}
        />
      )}

      {doubleValidation && (
        <Dialog
          className="user-filter-popup project-filters"
          sx={{
            width: "100% !important",
            height: "100%",
            maxHeight: "fit-co",
          }}
          // fullScreen={fullScreen}
          open={doubleValidation}
          //  onClose={handleChangeno}
        >
          <Stack
            sx={{ p: "25px 25px", pb: "4px" }}
            direction="row"
            alignItems="center"
            spacing={2}
            justifyContent="flex-start"
          >
            {/* <ErrorIcon
              fontSize="inherit"
              style={{ color: "#f95b5b", fontSize: "24px" }}
            /> */}
            <Typography className="model-title">Confirmation</Typography>
          </Stack>
          <Box sx={{ p: "5px 25px 0px 25px" }}>
            <p className="label">
              Are you sure you want to generate this consolidated invoice?
            </p>
          </Box>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              p: "20px 25px",
              pt: "21px",
            }}
          >
            <Button
              className="filter-btn"
              onClick={() => handleClosingInvoiceYesClick()}
            >
              Generate
            </Button>
            <Button
              className="cancel-btn"
              onClick={handleClosingInvoiceNoClick}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
